import React from 'react'
import { ReactComponent as PlusSVG } from '../../../assets/svg/plus.svg'
import { ReactComponent as MinusSVG } from '../../../assets/svg/minus.svg'
import SFXS from '../../../assets/audios/audios'

interface buttonProp {
  name: string
  content: string | JSX.Element
  longPressEnabled?: boolean
  SFX?: any
}
export const buttons: buttonProp[] = [
  { name: '1/2', content: '1/2', SFX: SFXS.divideSFX },
  { name: '2x', content: '2X', SFX: SFXS.multiplySFX },
  { name: '5x', content: '5X', SFX: SFXS.multiplySFX },
  {
    name: 'minus',
    content: <MinusSVG />,
    longPressEnabled: true,
    SFX: SFXS.divideSFX,
  },
  {
    name: 'plus',
    content: <PlusSVG />,
    longPressEnabled: true,
    SFX: SFXS.multiplySFX,
  },
]

